import clsx from "clsx";
import { GeneralRoutingLinkButton } from "components/Molecules/GeneralRoutingLinkButton";
import { PipelineRoutingLinkButton } from "components/Molecules/PipelineRoutingLinkButton";
import { ComponentAtomsLink } from "types/graphql/generated";

interface MobileBottomCtaProps {
  getStartedButton: ComponentAtomsLink;
  loginButton: ComponentAtomsLink;
  shouldHide: boolean;
}

export const MobileBottomCta = ({ shouldHide = false, getStartedButton, loginButton }: MobileBottomCtaProps) => {
  const animationClasses = "invisible opacity-0 translate-y-[100%]";

  const classes = clsx(
    "absolute bottom-0 left-0 z-10 flex h-mobile-cta w-full justify-end gap-4 border-t border-fog-20 bg-white px-6 py-4 shadow-mobile-mobile-cta transition-all duration-300 ease-in-out",
    {
      [animationClasses]: shouldHide,
    }
  );

  return (
    <div className={classes}>
      <GeneralRoutingLinkButton variant="outline" href={loginButton.url} className="min-w-1/2 w-auto max-w-52 flex-1">
        {loginButton.label}
      </GeneralRoutingLinkButton>
      <PipelineRoutingLinkButton href={getStartedButton.url} className="min-w-1/2 w-auto max-w-52 flex-1">
        {getStartedButton.label}
      </PipelineRoutingLinkButton>
    </div>
  );
};
